<ion-item class="question-item date-item" [formGroup]="form">
  <ion-label position="stacked" *ngIf="label">{{ label }}</ion-label>
  <div class="date-trigger-button"
    [class.emptyDateTimeStyle]="(form.get(inputName) != null) && (form.get(inputName).value === '' || form.get(inputName).value === undefined || form.get(inputName).value === null)"
    (click)="openPicker()">
    <span *ngIf="displayValue">{{ displayValue }}</span>
    <span *ngIf="!displayValue">Select date and time</span>
  </div>
  <ion-modal [isOpen]="isPickerOpen" [backdropDismiss]="false" (didDismiss)="onModalDismiss()"
             cssClass="ion-datetime-button-overlay calendar-picker-modal">
    <ng-template>
      <div class="datetime-picker-wrapper">
        <div class="datetime-picker-header">
          <ion-button fill="clear" (click)="onCancelClick()">{{ 'SHARED_TEXT.CANCEL' | translate }}</ion-button>
          <ion-button fill="clear" (click)="onConfirmClick()"><strong>{{ 'SHARED_TEXT.DONE' | translate }}</strong></ion-button>
        </div>
        <ion-datetime
          presentation="date-time"
          hourCycle="h23"
          max="2050"
          [formControlName]="inputName"
          [id]="dtId"
        ></ion-datetime>
      </div>
    </ng-template>
  </ion-modal>
</ion-item>
